<template>
  <div class="overflow-x-auto py-2 w-min">
    <div class="flex items-center gap-2 w-min">
      <button
        class="px-4 h-12 flex items-center text-sm whitespace-nowrap !no-underline !text-black rounded-md !shadow"
        :class="{
          'pointer-events-none bg-gray-50': !pages?.previous,
        }"
        @click="toPreviousPage"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <div v-for="pageItem in pagesDisplay" :key="pageItem.index">
        <button
          v-if="pageItem.useRoute"
          class="px-4 h-12 flex items-center text-sm whitespace-nowrap !no-underline !text-black rounded-md !shadow"
          :class="{
            'bg-sky-600': currentPage === pageItem.route,
            'bg-sky-400': currentPage !== pageItem.route,
          }"
          @click="toNumberPage(pageItem.route)"
        >
          {{ pageItem.display }}
        </button>
        <div v-else>
          <input
            class="px-2 h-12 w-16 flex items-center text-center whitespace-nowrap !no-underline !text-black rounded-md !shadow"
            placeholder="..."
            ref="customPageInput"
            @input="event => (customPage = event.target.value)"
            @keydown.enter="onCustomPageInput()"
            @focusout="onCustomPageInput()"
          />
        </div>
      </div>
      <button
        class="px-4 h-12 flex items-center whitespace-nowrap !no-underline !text-black rounded-md !shadow"
        :class="{
          'pointer-events-none bg-gray-50': !pages?.next,
        }"
        @click="toNextPage"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initPage: Number,
    pages: Object,
  },
  data() {
    return {
      customPage: undefined,
      currentPage: 1,
    }
  },
  methods: {
    toPreviousPage() {
      if (this.pages.previous) {
        this.$emit('toPage', this.pages.previous)
      }
    },
    toNextPage() {
      if (this.pages.next) {
        this.$emit('toPage', this.pages.next)
      }
    },
    toNumberPage(pageNumber) {
      this.$emit('toPage', pageNumber)
    },
    onCustomPageInput() {
      for (const inputField of this.$refs.customPageInput) {
        inputField.value = ''
      }

      let customPage = parseInt(this.customPage)
      if (isNaN(customPage)) {
        return
      } else if (customPage <= 0 || customPage > this.pages.total) {
        customPage = 1
      }

      this.$emit('toPage', customPage)
    },
  },
  mounted() {
    this.currentPage = this.initPage
  },
  watch: {
    pages(newValue) {
      this.currentPage = newValue.curr
    }
  },
  computed: {
    pagesDisplay() {
      if (this.pages === undefined || this.pages.page_range === undefined) {
        return []
      }

      return this.pages.page_range.map((element, index) => {
        if (element !== '…') {
          return {
            index: index,
            display: element,
            useRoute: true,
            route: element,
          }
        } else {
          return {
            index: index,
            display: '...',
            useRoute: false,
          }
        }
      })
    },
  },
}
</script>

<style></style>
